import { h } from 'preact'
import { useState, useEffect, useRef } from 'preact/hooks'
import { tagParser } from '../../js/modules/utilities'

import imageLargeX2 from './2880x1240.jpg'
import imageSmallX2 from './pro.jpg'
import title from './title.svg'

/* TEST

* verifier le mode précommande / commande
* verifier la pose du cookie
* verifier que cookie monster ne le supprime pas
* verfier le responsive / mobile / player video
* verifier le taggage
* verifier l'URL de redirection

*/

export const Campagne = ({ type }) => {
   const data = {
      preco: {
         cookieValue: JSON.stringify({ precommande_iphone_16: 1 }),
         title: title,
         subtitle: '[price]70€[/price] de remise immédiate.',
         imageLargeX2: imageLargeX2,
         imageSmallX2: imageSmallX2,
         button: {
            label: 'Précommander',
            URL: 'https://boutique.orange.fr/mobile/mobiles-et-smartphones?segment=famille16',
            analytics: {
               pdbZid: 'acc-digital_' + dataStoreHP.segRefZ + '_event_preco',
               oeventCategory: 'zone_evenementielle',
               oeventAction: 'precommande_apple_16',
               oeventLabel: 'https://boutique.orange.fr/mobile/mobiles-et-smartphones?segment=famille16',
               oeventOther: JSON.stringify({
                  track_refZ: 'acc-digital_' + dataStoreHP.segRefZ + '_event_preco',
               }),
            },
         },
         DAS: 'DAS tête : 1,24 W/kg, tronc : 1,91 W/kg, membre : 1,48 W/kg.',
      },
      commande: {
         cookieValue: JSON.stringify({ commande_iphone_16: 1 }),
         title: 'Nouveauté Apple',
         subtitle: 'iPhone 15 Pro',
         alt: 'iPhone 15 Pro',
         content: {
            tag: 'Nouveauté',
            title: 'iPhone Max Super Canard',
            attributes: [
               { icon: 'icon-internet', label: 'Internet à la maison' },
               { icon: 'icon-mon-reseau', label: 'Wifi Premium' },
               { icon: 'icon-orange-tv', label: "TV d'Orange" },
            ],
            tooltip: {
               title: 'DAS',
               content: {
                  head: '0,99 W/kg',
                  trunk: '0,98 W/kg',
                  members: '2,97 W/kg',
               },
            },
            price: {
               from: 'à partir de',
               amount: '18,99 €',
               srOnly: 'À partir de 18,99€',
            },
            button: {
               label: 'Commander',
               link: 'https://www.orange.fr/',
               oevent: {
                  pdbZid: 'acc-digital_' + dataStoreHP.segRefZ + '_event',
                  category: 'zone_evenementielle',
                  action: 'commande_apple_16',
                  label: 'https://www.orange.fr/',
                  other: {
                     track_refZ: 'acc-digital_' + dataStoreHP.segRefZ + '_event',
                  },
               },
            },
         },
      },
   }

   if (type === 'preco') {
      return <CampagnePomme {...data.preco} />
   }

   if (type === 'commande') {
      return <CampagnePomme {...data.commande} />
   }
}

const CampagnePomme = (props) => {
   // Video
   // const [isPlaying, setIsPlaying] = useState(true)
   // const videoRef = useRef(null)
   // const playPauseButtonRef = useRef(null)

   useEffect(() => {
      // Cookie de capping
      const nbJoursCookie = 20
      document.cookie = `o-HPevent=${props.cookieValue}; max-age=${60 * 60 * 24 * nbJoursCookie}; path=/`

      // Video
      // const videoElement = videoRef.current
      // const playPauseButton = playPauseButtonRef.current

      // const handlePlayPause = () => {
      //    if (videoElement.paused) {
      //       videoElement.play()
      //       setIsPlaying(true)
      //    } else {
      //       videoElement.pause()
      //       setIsPlaying(false)
      //    }
      // }

      // const handleVideoEnded = () => {
      //    setIsPlaying(false)
      // }

      // playPauseButton.addEventListener('click', handlePlayPause)
      // videoElement.addEventListener('ended', handleVideoEnded)

      // return () => {
      //    playPauseButton.removeEventListener('click', handlePlayPause)
      //    videoElement.removeEventListener('ended', handleVideoEnded)
      // }
   }, [])

   return (
      <div class="campagne">
         <img src={props.title} alt="" class="title" />
         <picture>
            <source srcset={props.imageSmallX2} media="(max-width: 735px)" />
            <img src={props.imageLargeX2} alt="" class="imageFond" />
         </picture>
         <div class="content">
            <h3 class="subtitle h4" dangerouslySetInnerHTML={{ __html: tagParser(props.subtitle) }} />
            <a
               href={props.button.URL}
               class="btn btn-primary btn-inverse"
               data-pdb-zid={props.button.analytics.pdbZid}
               data-oevent-category={props.button.analytics.oeventCategory}
               data-oevent-action={props.button.analytics.oeventAction}
               data-oevent-label={props.button.analytics.oeventLabel}
               data-oevent-other={props.button.analytics.oeventOther}
            >
               {props.button.label}
            </a>
            <span class="das">{props.DAS}</span>
         </div>
      </div>
   )
}

{
   /* <video
            id="bgVideo"
            ref={videoRef}
            playsinline // Mobile browsers will play the video right where it is instead of the default, which is to open it up fullscreen while it plays.
            autoplay
            preload="auto"
            muted
            poster="//proxymedia.woopic.com/api/v1/images/1394%2Fportal-orangepro%2Fmagic%2Fescda%2Ficons%2F6d6aeaf0267708d8ae51c983aada4ef7.jpg?saveas=webp&amp;quality=85&amp;saveasquality=65&amp;facedetect=1"
         >
            <source src="https://cdn.woopic.com/840aa06aeef64c848738c7997ff75b62/portal-orangepro/magic/escda/b2aeabdbd717510fbce7c7825e2c975e.mp4" type="video/mp4" />
            <source src="https://cdn.woopic.com/840aa06aeef64c848738c7997ff75b62/portal-orangepro/magic/escda/fcd46fa977c577e1de6a15cb613d8ab6.mp4" type="video/mp4" />
            <source src="https://cdn.woopic.com/840aa06aeef64c848738c7997ff75b62/portal-orangepro/magic/escda/50e70ab54623d08042bf5a8e4f0d09f2.webm" type="video/webm" />
         </video>
         <div class="video-controls">
            <button id="playPauseButton" class="play-pause-button" ref={playPauseButtonRef}>
               {isPlaying ? 'Pause' : 'Play'}
            </button>
         </div> */
}
